import { useContext, useState, useMemo, useEffect } from 'react'
import _ from "lodash"

import { Typography, Button, Tooltip } from '@mui/material'
import EastRoundedIcon from '@mui/icons-material/EastRounded'

import { PassContext } from '../pass-context'
import PopupEditor from './popup-editor'
import PopupShell from '../popup-shell'

const PopupDialogStampcardImages = ({ open, close }) => {

  const { device, scannerData, setScannerData,setScannerInstanceData, setInstanceData } = useContext(PassContext)

  const [newScannerData, setNewScannerData] = useState()

  useEffect(() => {
    if (open) {
      setNewScannerData(_.cloneDeep(scannerData))
    }
  }, [open])

  const dataChanged = useMemo(() => !_.isEqual(newScannerData, scannerData), [newScannerData])

  const imageItem = (index, url) => {
    
    const saveNewUrl = newUrl => {
      setNewScannerData(prev => {
        let sd = {...prev}
        sd.stamp_images[device][index] = newUrl
        return sd
      })
    }

    return (
      <div key={index} className='flex flex-col justify-between items-start mb-5'>
        <Typography variant='h6'>{index} Stamps</Typography>
        <PopupEditor title={`Stampcard Image - ${index} stamps`} path="meta.images.stampcard" saveFunction={saveNewUrl} stampcardUrl={url} stampcardIndex={index}>
          <img src={url + "?cb=stampcards"} className='apple-width' style={{border:url.length ? "none" : "1px dashed",minHeight:"120px"}} crossOrigin="anonymous"/>
        </PopupEditor>
      </div>
    )
  }

  const imageItems = useMemo(() => {
    if (newScannerData) {
      return newScannerData.stamp_images[device].map((url, idx) => imageItem(idx, url))
    }
  }, [newScannerData])

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Support Functions
  //////////////////////////////////////////////////////////////////////////////////////////////////////////


  const handleClose = (e, reason) => {
    if (reason && reason === "backdropClick")
      return
    close()
  }

  const saveFormData = () => {
    // Save the paths to all the images
    setScannerData(newScannerData)

    // Set the default image to zero stamps
    setScannerInstanceData(prev => {
      let sid = {...prev}
     _.set(sid, "__apple_image__:image", newScannerData.stamp_images[device][0])
     return sid
    })

    // Set the preview image to 5 stamps
//    setInstanceData(prev => {
//      let id = {...prev}
//     _.set(id, "__scanner_data__.__apple_image__", newScannerData.stamp_images[device][5])
//     return id
//    })

    close()
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Main Render
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <PopupShell open={open} onClose={handleClose}>
        <div className="flex flex-col h-full gap-2">
        <div className="flex flex-row justify-between mt-5">
          <Typography color="secondary" variant="h6">Stampcard images</Typography>
          <Tooltip title="You can press ESC on your keyboard to dismiss"><Button endIcon={<EastRoundedIcon />} onClick={handleClose} >cancel</Button></Tooltip>
        </div>

        <div className='mt-5 overflow-y-scroll flex flex-col gap-5 mb-[100px]'>
          {imageItems}
        </div>

        <div className='fixed bottom-5 w-[460px]'>
          <hr className='mb-5' />
          <div className="flex flex-row gap-5 justify-end">
            <Button variant="contained" onClick={saveFormData} disabled={!dataChanged}>Save</Button>
          </div>
        </div>

      </div>
    </PopupShell>
  )
}


export default PopupDialogStampcardImages
